import React from "react";

import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import { GRID_COL_INDEX_ATTRIBUTE } from "@progress/kendo-react-grid";
import DropDownEnum from "../sys-common/DropDownEnum";

export default function GridEnumCell(props) {
  const value = props.dataItem[props.field];
  const navigationAttributes = useTableKeyboardNavigation(props.id);
  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: props.dataIndex,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value.value,
      });
    }
  };
  return (
    <td
      style={{ whiteSpace: "nowrap" }}
      title={value}
      aria-selected={props.isSelected}
      colSpan={props.colSpan}
      aria-colindex={props.ariaColumnIndex}
      {...{ [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex }}
      {...navigationAttributes}
    >
      {props.edit ? (
        <DropDownEnum
          value={value}
          name={props.field}
          onChange={handleChange}
          enums={props.enum}
        />
      ) : (
        value
      )}
    </td>
  );
}
